import React from 'react';
import Modal from '@carvana/showroom-modal';
import {
  ContentBody,
  ContentHeader,
  ContentWrapper,
} from './UpdateBankWarningDialog.styles';
import DocWarningIcon from '../../../assets/doc-warning-icon';

const UpdateBankWarningDialog = (props: {
  openModal: boolean;
  toggleModal: any;
}) => {
  const title =
    'YOU ARE USING THIS ACCOUNT FOR AUTOPAY AND/OR A SCHEDULED PAYMENT to bridgecrest';
  const body =
    'You need to turn off autopay and/or cancel scheduled payments before changing your bank information.';

  const { openModal, toggleModal } = props;

  return (
    <Modal
      headerText="UPDATE BANK DETAILS"
      mode="light"
      isOpen={openModal}
      closeModal={toggleModal}
    >
      <ContentWrapper>
        <DocWarningIcon />
        <ContentHeader>{title}</ContentHeader>
        <ContentBody>{body}</ContentBody>
      </ContentWrapper>
    </Modal>
  );
};

export default UpdateBankWarningDialog;
